import classnames from 'classnames';
import './index.less';

interface LoadingProps {
  loading?: boolean;
}

export function Loading(
  props: LoadingProps & React.HTMLAttributes<HTMLDivElement>,
) {
  const { className, children, loading, ...otherProps } = props;

  const loadingElement = (
    <div className={classnames('mag-loading', className)} {...otherProps}></div>
  );

  if (children) {
    return (
      <div className="mag-loading-container">
        <div className="mag-loading-content">{children}</div>
        {loading && <div className="mag-loading-blur">{loadingElement}</div>}
      </div>
    );
  } else {
    return loadingElement;
  }
}
